import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const ManagementReportingMIS = () => {
  const serviceData = {
    title: "MIS & Management Reporting",
    heading: "MIS & Management Reporting",
    image: subTopicImages["MIS & Management Reporting"],
    intro:
      "Beyond accounting numbers, management requires clear financial insight to guide decision-making.",
    description: [
      "We design tailored MIS and performance reports to provide meaningful business intelligence.",
    ],
    services: [
      {
        title: "MIS & Reporting Deliverables",
        text: "Typical MIS deliverables include:",
        list: [
          "profitability and cost analysis",
          "product / region / customer-wise reporting",
          "KPI dashboards",
          "cash-flow review",
          "budget vs actuals",
          "operational trend analysis",
        ],
        extraInfo:
          "Reports are prepared in formats suited for promoters, Board presentations, investors, and regional / global HQ reporting.",
      },
    ],
    benefitsIntro: "",
    benefits: [
      "Our MIS frameworks help management monitor business health, identify improvement areas and support strategy execution.",
    ],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default ManagementReportingMIS;
